import { Button, Popconfirm, Tooltip } from 'antd';
import { useNavigate } from "react-router-dom";
import { EyeFilled, EditFilled, DeleteFilled, SignalFilled, MergeFilled, KeyOutlined, CheckCircleFilled, CloseCircleFilled, FolderOpenFilled } from '@ant-design/icons';
import dayjs from 'dayjs';

const Columns = (showModal, handleDelete, filters, handleOpenChangeLog, handlePasswordReset) => {
  const navigate = useNavigate();

  const renderStatusIcon = (active) => {
    return active ? (
      <Tooltip title="Activo">
        <CheckCircleFilled  style={{ color: '#63c000', fontSize: 15 }} />
      </Tooltip>
    ) : (
      <Tooltip title="Inactivo">
        <CloseCircleFilled style={{ color: 'red', fontSize: 15 }} />
      </Tooltip>
    );
  };

  return [
    {
      title: "Usuario",
      dataIndex: "username",
      key: "username",
      sorter: (a, b) => a.username.localeCompare(b.username),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '35%',
    },
    {
      title: "Nombre",
      dataIndex: "first_name",
      key: "first_name",
      sorter: (a, b) => a.first_name.localeCompare(b.first_name),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '20%',
    },
    {
      title: "Apellido",
      dataIndex: "last_name",
      key: "last_name",
      sorter: (a, b) => a.last_name.localeCompare(b.last_name),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '18%',
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '42%',
    },
    {
      title: "Área",
      dataIndex: "area",
      key: "area",
      render: (area) => area?.name || '-',
      sorter: (a, b) => (a.area?.name || '').localeCompare(b.area?.name || ''),
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' }
      }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Rol Asignado",
      dataIndex: "roles",
      key: "roles",
      render: (_, record) => {
        if (record.is_superuser) {
          return <span style={{ fontWeight: "bold" }}>Superusuario</span>;
        }
        return record.roles?.[0]?.name || "-";
      },
      sorter: (a, b) => {
        const nameA = a.is_superuser ? "Superusuario" : (a.roles?.[0]?.name || "");
        const nameB = b.is_superuser ? "Superusuario" : (b.roles?.[0]?.name || "");
        return nameA.localeCompare(nameB);
      },
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } 
      }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Último Inicio Sesión",
      dataIndex: "last_login_app",
      key: "last_login_app",
      render: (last_login_app) => last_login_app ? dayjs(last_login_app).format('DD/MM/YYYY HH:mm:ss') : '-',
      sorter: (a, b) => {
        const timeA = a.last_login_app ? dayjs(a.last_login_app).valueOf() : 0;
        const timeB = b.last_login_app ? dayjs(b.last_login_app).valueOf() : 0;
        return timeA - timeB;
      },
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' }
      }),
      showSorterTooltip: false,
      width: '26%',
    },
    {
      title: "Estado",
      dataIndex: "is_active",
      key: "is_active",
      sorter: (a, b) => Number(a.is_active) - Number(b.is_active),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      filters: [
        {
          text: (<><CheckCircleFilled style={{ color: '#63c000', marginRight: 5 }} />Activo</>),
          value: true,
        },
        {
          text: (<><CloseCircleFilled style={{ color: 'red', marginRight: 5 }} />Inactivo</>),
          value: false,
        },
      ],
      onFilter: (value, record) => record.is_active === value,
      render: (active) => renderStatusIcon(active ?? true),
      width: '15%',
      align: 'center',
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => (
        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
          <Button style={{ color: '#006939', fontSize: 18,  padding: '0px 2px' }} type="link" onClick={() => showModal(record)}>
            <Tooltip title="Editar usuario"><EditFilled /></Tooltip>
          </Button>
          {/* <Button 
            type="link" 
            style={{ color: '#F5A623', fontSize: 18, padding: '0px 2px' }}
            //onClick={() => navigate(`/assignment?tab=1&asset=${encodeURIComponent(record.name)}`)}
          >
            <Tooltip title="Asignar roles">
              <MergeFilled />
            </Tooltip>
          </Button> */}
          <Popconfirm 
            overlayClassName="custom-popconfirm"
            title="¿Seguro que quieres restablecer la contraseña?"
            //description={`Se enviará un correo a ${record.email} con instrucciones.`}
            onConfirm={() => handlePasswordReset(record)}
            okText="Sí, restablecer"
            cancelText="Cancelar"
          >
            <Button type="link" style={{ color: '#F5A623', fontSize: 18, padding: '0px 2px' }}>
              <Tooltip title="Restablecer Contraseña"><KeyOutlined /></Tooltip>
            </Button>
          </Popconfirm>
          <Tooltip title="Ver Log">
            <FolderOpenFilled 
              style={{ fontSize: 20, cursor: 'pointer', color: '#006939' }}
              onClick={() => handleOpenChangeLog(record)}
            />
          </Tooltip>
          <Popconfirm 
            overlayClassName="custom-popconfirm"
            title="¿Seguro que deseas eliminar este Usuario?"
            onConfirm={() => handleDelete(record.id)}
            disabled={record.is_superuser}
          >
            <Button 
              type="link"
              style={{ color: record.is_superuser ? '#999999' : '#006939', fontSize: 18, padding: '0px 2px' }}
              disabled={record.is_superuser}
            >
              <Tooltip placement='left' title="Eliminar Usuario"><DeleteFilled /></Tooltip>
            </Button>
          </Popconfirm>
        </div>
      ),
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', textAlign: 'center' } 
      }),
      align: 'center', 
      width: '20%',
    }  
  ];
};
  
export default Columns;  